import { Row, Col } from "antd";
import {
  Store,
  Network,
  BadgeHelp,
  Phone,
  Smartphone,
  Mail,
  MapPin,
  Globe,
  Building,
  Building2,
  Map,
} from "lucide-react";
import Subtitle from "../../Subtitle";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";

export default function PVSection(props) {
  const { verification, setVerification, hidden, loading } = props;

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 8,
  };

  return (
    <>
      <Subtitle title="Datos de la Razón social" marginTop={16} />
      <Row gutter={[16, 16]}>
        <Col {...responsiveInfo}>
          <DataGroup
            title={!verification?.NombreCompletoPV ? "Razón social" : verification?.NombreCompletoPV}
            subtitle={
              verification?.TipoPersonaPV_T && verification?.NacionalidadPV_T
                ? "Persona " + verification?.TipoPersonaPV_T + ", " + verification?.NacionalidadPV_T
                : null
            }
            formName={"Información de la Razón social"}
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<Store size={16} />}
              iconColor="purple"
              keyName="Nombre comercial"
              value={verification?.NombreComercial}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Network size={16} />}
              iconColor="orange"
              keyName="Clasificación SCIAN"
              value={verification?.ClasificacionSCIAN}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<BadgeHelp size={16} />}
              iconColor="brown"
              keyName={verification?.TipoDatoPV_T ? verification?.TipoDatoPV_T : "Tipo de identificación"}
              value={verification?.DatoPV_T}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Phone size={16} />}
              iconColor="#1890ff"
              keyName="Teléfono fijo"
              value={verification?.TelefonoFijoPV_T}
              valueType="phone"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Smartphone size={16} />}
              iconColor="indigo"
              keyName="Teléfono móvil"
              value={verification?.TelefonoMovilPV_T}
              valueType="phone"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Mail size={16} />}
              iconColor="#1890ff"
              keyName="Correo electrónico"
              value={verification?.CorreoElectronicoPV_T}
              valueType="email"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
        <Col {...responsiveInfo}>
          <DataGroup
            title={
              !verification?.NombreCalle
                ? "Domicilio"
                : verification?.NombreCalle +
                  `${verification?.NumeroOficial ? " " + verification?.NumeroOficial : " S/N"}` +
                  `${verification?.ColoniaOAsentamiento ? ", Col. " + verification?.ColoniaOAsentamiento : ""}`
            }
            subtitle={
              verification?.EntreCalle1 && verification?.EntreCalle2
                ? `Entre ${verification?.EntreCalle1} y ${verification?.EntreCalle2}`
                : null
            }
            formName={"Domicilio de la Razón social"}
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<MapPin size={16} />}
              iconColor="red"
              keyName="Código postal"
              value={verification?.CodigoPostal}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Building size={16} />}
              iconColor="#1890ff"
              keyName="Ciudad"
              value={verification?.Ciudad}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Building2 size={16} />}
              iconColor="#82cc4b"
              keyName="Municipio"
              value={verification?.Municipio}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Map size={16} />}
              iconColor="#ffc53d"
              keyName="Estado"
              value={verification?.Estado}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Globe size={16} />}
              iconColor="red"
              keyName="Link Google Maps"
              value={verification?.LinkMaps}
              valueType="string"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
      </Row>
    </>
  );
}